import { Component } from 'react'
import PropTypes from 'prop-types'
import * as _ from 'lodash'
import { withTranslation } from 'react-i18next'

import SelectField from '../FormLegacy/FormFields/SelectField'
import { StripePaymentButton } from '../Popups/stripe-payment-modal'
import API from '../../api/api'
import EmailField from '../FormLegacy/FormFields/EmailField'
import TextField from '../FormLegacy/FormFields/TextField'
import { EMAIL_REGEX } from '../../helpers/constants'

import DiscountCodeInput from './DiscountCodeInput'
import TransactionFinishedPopup from './TransactionFinishedPopup'

class StoreProductSKU extends Component {
  constructor(props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
    this.state = {
      chosenSKU: null,
      promoCodeVisible: false,
      promoCodeValid: false,
      promoCode: '',
      giftCardVisible: false,
      giftCard: '',
      giftCardValid: false,
      validating: false,
      discountedCost: null,
      recipientEmail: '',
      recipientEmailError: false,
      giftMessage: '',
      giftCardValidationError: '',
      promoCodeValidationError: '',
      transactionPopupOpen: false,
      transactionStatus: '',
      transactionId: '',
      transactionCost: 0,
    }
    this.handleInput = this.handleInput.bind(this)
    this.validateEmail = this.validateEmail.bind(this)
    this.validateDiscountCode = this.validateDiscountCode.bind(this)
    this.handleCode = this.handleCode.bind(this)
    this.setValidationState = this.setValidationState.bind(this)
    this.closeFinishedTransactionPopup = this.closeFinishedTransactionPopup.bind(this)
    this.buyForFree = this.buyForFree.bind(this)
  }

  handleSelect(value) {
    const { sku } = this.props.product
    this.setState({
      chosenSKU: sku.filter((sku) => sku.id === value)[0],
      promoCodeVisible: false,
      promoCodeValid: false,
      promoCode: '',
      giftCardVisible: false,
      giftCard: '',
      giftCardValid: false,
      validating: false,
      discountedCost: null,
      giftCardValidationError: '',
      promoCodeValidationError: '',
    })
  }

  handleInput(name, value) {
    this.setState({ [name]: value })
  }

  validateEmail(val) {
    const isValid = val.length > 0 && EMAIL_REGEX.test(val)
    this.setState({ recipientEmailError: !isValid })
  }

  setValidationState(res) {
    const promoCodeError = res.errors.find((msg) => msg.type === 'Promo code')
    const giftCardError = res.errors.find((msg) => msg.type === 'Gift card')

    const setValidState = (error, type) => {
      if (typeof error !== 'undefined') {
        if (this.state[type] !== '') {
          this.setState({
            [`${type}ValidationError`]: error.message,
            [`${type}Valid`]: false,
          })
        } else {
          this.setState({
            [`${type}ValidationError`]: '',
            [`${type}Valid`]: false,
          })
        }
      } else {
        this.setState({
          [`${type}ValidationError`]: '',
          [`${type}Valid`]: true,
        })
      }
    }

    setValidState(promoCodeError, 'promoCode')
    setValidState(giftCardError, 'giftCard')

    this.setState({ validating: false })
  }

  validateDiscountCode() {
    this.setState({ validating: true })
    const { chosenSKU, giftCard, promoCode } = this.state
    const gift = giftCard !== '' ? giftCard : 'undefined'
    const promo = promoCode !== '' ? promoCode : 'undefined'
    API.validateProductCodes(chosenSKU.id, gift, promo)
      .then((res) => {
        this.setValidationState(res)
        this.setState({ discountedCost: res.price })
      })
      .catch((err) => {
        this.setValidationState(err)
        this.setState({ discountedCost: err.price })
      })
  }

  handleCode(e) {
    const { name, value } = e.target
    this.handleInput(name, value)
    const debounceValidate = _.debounce(this.validateDiscountCode, 300)
    debounceValidate()
  }

  showDiscountInput(e, name) {
    e.preventDefault()
    this.setState({ [`${name}Visible`]: true })
  }

  closeFinishedTransactionPopup() {
    this.setState({
      transactionPopupOpen: false,
      transactionStatus: '',
      transactionId: '',
      transactionCost: 0,
    })
  }

  buyForFree(e) {
    e.preventDefault()
    const {
      chosenSKU,
      promoCodeValid,
      promoCode,
      giftCard,
      giftCardValid,
      recipientEmail,
      giftMessage,
    } = this.state
    const recipient = recipientEmail || false
    const message = giftMessage || false
    const gift = giftCardValid ? giftCard : false
    const promo = promoCodeValid ? promoCode : false
    this.setState({ transactionStatus: 'pending', transactionPopupOpen: true })
    API.buyProduct(chosenSKU.id, 'cycki', recipient, message, gift, promo)
      .then(() => {
        this.setState({
          transactionStatus: 'success',
          transactionCost: 0,
          transactionId: 0,
        })
      })
      .catch(() => {
        this.setState({
          transactionStatus: 'failed',
          transactionCost: 0,
          transactionId: 0,
        })
      })
  }

  render() {
    const { product, userEmail, t } = this.props
    const options = product.sku.map((sku) => ({
      value: sku.id,
      label: `${sku.name} ${sku.duration} min.`,
    }))
    const {
      chosenSKU,
      promoCodeValid,
      promoCode,
      giftCard,
      giftCardValid,
      validating,
      discountedCost,
      giftCardValidationError,
      promoCodeValidationError,
      recipientEmail,
      recipientEmailError,
      giftMessage,
      transactionPopupOpen,
      transactionStatus,
      transactionId,
      transactionCost,
    } = this.state
    const isDiscount = discountedCost !== null && discountedCost !== chosenSKU.cost
    return (
      <div className="ctp-store-product__sku">
        <div className="columns">
          <div className="column">
            <SelectField options={options} onChange={(e, value) => this.handleSelect(value)} />
          </div>
          <div className="column">
            {discountedCost !== 0 && (
              <StripePaymentButton
                email={userEmail}
                amount={
                  discountedCost === null && chosenSKU !== null ? chosenSKU.cost : discountedCost
                }
                disabled={chosenSKU === null}
                className={`button button-primary ${validating && 'is-loading'} button--buy-modal`}
                description={
                  chosenSKU !== null
                    ? t('store:productSku.buyNamed', { name: chosenSKU.name })
                    : t('store:productSku.selectProduct')
                }
                buttonLabel={
                  chosenSKU !== null
                    ? t('store:productSku.buyProduct')
                    : t('store:productSku.selectProduct')
                }
                context={{
                  skuId: chosenSKU ? chosenSKU.id : -1,
                  ...(promoCodeValid && promoCode && { promoCode }),
                  ...(giftCardValid && giftCard && { giftCard }),
                  ...(recipientEmail && { recipient: recipientEmail }),
                  ...(giftMessage && { giftMessage }),
                }}
                onPaymentSuccess={() =>
                  this.setState({ transactionStatus: 'success', transactionPopupOpen: true })
                }
                onPaymentError={() =>
                  this.setState({
                    transactionStatus: 'failed',
                    transactionPopupOpen: true,
                    transactionCost: 0,
                    transactionId: 0,
                  })
                }
              />
            )}
            {discountedCost === 0 && (
              <button className={`button button-primary`} onClick={this.buyForFree}>
                {t('store:productSku.buyProduct')}
              </button>
            )}
          </div>
        </div>
        {chosenSKU !== null && (
          <div className="columns">
            <div className="column">
              <div className="ctp-store-product__price">
                <strong>
                  {t('store:productSku.price')}
                  <span className={`${isDiscount ? 'is-striked' : ''}`}> ${chosenSKU.cost}</span>
                </strong>
                {isDiscount && (
                  <strong>
                    {t('store:productSku.toPay')}
                    <span>${discountedCost}</span>
                  </strong>
                )}
              </div>
            </div>
            <div className="column">
              {product.category !== 'Gift' && (
                <div>
                  <DiscountCodeInput
                    name={'promoCode'}
                    value={promoCode}
                    placeholder={t('store:productSku.promoCode.placeholder')}
                    onChange={this.handleCode}
                    showCodeInput={(e) => this.showDiscountInput(e, 'promoCode')}
                    showCodeText={t('store:productSku.promoCode.gotCode')}
                    inputVisible={this.state.promoCodeVisible}
                    isValid={promoCodeValid}
                    error={promoCodeValidationError}
                  />
                  <DiscountCodeInput
                    name={'giftCard'}
                    value={giftCard}
                    placeholder={t('store:productSku.giftCard.placeholder')}
                    onChange={this.handleCode}
                    showCodeInput={(e) => this.showDiscountInput(e, 'giftCard')}
                    showCodeText={t('store:productSku.giftCard.gotCode')}
                    inputVisible={this.state.giftCardVisible}
                    isValid={giftCardValid}
                    error={giftCardValidationError}
                  />
                </div>
              )}
              {product.category === 'Gift' && (
                <div className={'form'}>
                  <EmailField
                    fieldName={'recipientEmail'}
                    label={t('store:productSku.email.label')}
                    placeholder={t('store:productSku.email.placeholder')}
                    onChange={(e) => {
                      this.handleInput(e.target.name, e.target.value)
                      this.validateEmail(e.target.value)
                    }}
                    value={recipientEmail}
                    isDisabled={false}
                    showErrorLabel={true}
                    additionalClass={recipientEmailError ? 'is-danger' : ''}
                  />
                  <TextField
                    fieldName={'giftMessage'}
                    label={t('store:productSku.message.label')}
                    placeholder={t('store:productSku.message.placeholder')}
                    onChange={(e) => this.handleInput(e.target.name, e.target.value)}
                    value={giftMessage}
                    isDisabled={false}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <TransactionFinishedPopup
          title={t('store:productSku.transaction.title')}
          isOpen={transactionPopupOpen}
          closeText={t('common:actions.close')}
          transactionStatus={transactionStatus}
          cost={transactionCost}
          transactionId={transactionId}
          closeCallback={this.closeFinishedTransactionPopup}
        />
      </div>
    )
  }
}
StoreProductSKU.propTypes = {
  product: PropTypes.object,
  userEmail: PropTypes.string,
  t: PropTypes.func,
}
export default withTranslation(['store', 'common'])(StoreProductSKU)
